"use client";
import * as React from "react";

type TextAreaProps = {
  id: string;
  label: string;
  value: string;
  classNames?: {
    textarea?: string;
    label?: string;
    container?: string;
  };
  handleInputChange: (e: any) => void;
} & JSX.InputHTMLAttributes<HTMLTextAreaElement>;
import styles from "../index.module.css";
import Spacer from "../../Spacer/index";
import cssClassAssembler from "../../../sso/utils/cssClassAssembler";

function TextArea(props: TextAreaProps) {
  function textAreaHTMLAttributes() {
    const { id, label, value, classNames, handleInputChange, ...rest } = props;
    return rest;
  }

  function cssClass() {
    return {
      container: cssClassAssembler(
        props.classNames?.container,
        styles.container
      ),
      textarea: cssClassAssembler(props.classNames?.textarea, styles.textarea),
      label: cssClassAssembler(props.classNames?.label, styles.label),
    };
  }

  return (
    <div className={styles.container}>
      <label htmlFor={props.id} className={styles.label}>
        {props.label}
      </label>
      <Spacer y={2} />
      <textarea
        id={props.id}
        value={props.value}
        className={cssClass().textarea}
        onChange={(event) => props.handleInputChange(event)}
        {...textAreaHTMLAttributes()}
      />
    </div>
  );
}

export default TextArea;
